// extracted by mini-css-extract-plugin
export default {"boxIllustration":"NvnAfJLjlHf6sJkHc0Hz"};